import styled from 'styled-components';

export const SectionHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const ContextStrip = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #696969;
`;

export const ContextValue = styled.strong`
  color: #303030;
  font-weight: 600;
`;

export const Blocked = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  background: #fff7e6;
  border: 1px solid #fcd9a3;
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #92400e;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
`;

export const Th = styled.th<{ $align?: 'left' | 'right' | 'center' }>`
  text-align: ${({ $align }) => $align ?? 'left'};
  padding: 8px 10px;
  border-bottom: 1px solid #dde1e5;
  color: #94a3b8;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const Td = styled.td<{ $align?: 'left' | 'right' | 'center' }>`
  text-align: ${({ $align }) => $align ?? 'left'};
  padding: 10px;
  border-bottom: 1px solid #f1f3f5;
  color: #303030;
  vertical-align: middle;
`;

export const Ncm = styled.span`
  font-family: 'Roboto Mono', monospace;
  font-size: 0.8rem;
  color: #696969;
`;

export const ScenarioTag = styled.span<{ $missing?: boolean }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
  background: ${({ $missing }) => ($missing ? '#fff7e6' : '#eef7f4')};
  color: ${({ $missing }) => ($missing ? '#92400e' : '#0f766e')};
  border: 1px solid ${({ $missing }) => ($missing ? '#fcd9a3' : '#bfe0d7')};
`;

/**
 * Três pesos, sem selo: herdado do cenário fica apagado, editado ganha contraste
 * e borda de destaque, vazio fica tracejado.
 */
export const RateInput = styled.input<{ $edited?: boolean; $empty?: boolean }>`
  width: 84px;
  padding: 6px 9px;
  text-align: right;
  font-family: 'Roboto Mono', monospace;
  font-size: 0.82rem;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.15s, color 0.15s;

  background: ${({ $edited, $empty }) => {
    if ($empty) return 'transparent';
    return $edited ? '#f0f9ff' : '#fff';
  }};
  color: ${({ $edited }) => ($edited ? '#303030' : '#696969')};
  font-weight: ${({ $edited }) => ($edited ? 600 : 400)};
  border: ${({ $edited, $empty }) => {
    if ($edited) return '1.5px solid #0090d3';
    if ($empty) return '1px dashed #c4c9cf';
    return '1px solid #dde1e5';
  }};

  &:focus {
    border-color: #0090d3;
  }

  &::placeholder {
    color: #b6bcc3;
  }
`;

export const FixedRate = styled.span`
  display: inline-block;
  width: 84px;
  padding: 6px 9px;
  text-align: right;
  font-family: 'Roboto Mono', monospace;
  font-size: 0.82rem;
  color: #696969;
  white-space: nowrap;
`;

export const IpiCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;

export const OrigemIpiChip = styled.span<{ $semRegra?: boolean }>`
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 1px 6px;
  border-radius: 100px;
  white-space: nowrap;
  background: ${({ $semRegra }) => ($semRegra ? '#fdecee' : '#f1f3f5')};
  color: ${({ $semRegra }) => ($semRegra ? '#c53030' : '#94a3b8')};
`;

export const Projected = styled.span<{ $muted?: boolean }>`
  font-family: 'Roboto Mono', monospace;
  font-size: 0.82rem;
  color: ${({ $muted }) => ($muted ? '#b6bcc3' : '#303030')};
  white-space: nowrap;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #dde1e5;
`;

export const FooterNote = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 0.76rem;
  color: #94a3b8;
  font-style: italic;
`;

export const FooterTotal = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  color: #303030;

  strong {
    font-family: 'Roboto Mono', monospace;
    font-weight: 600;
    margin-left: 8px;
  }
`;

export const EmptyHint = styled.p`
  margin: 16px 0 0;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #696969;
`;
